
import { ReducerRegistry } from '../base/redux';

import {
    ADD_DONORBOX_URL,
    RECEIVE_DONORBOX_URL,
    REMOVE_DONORBOX_URL,
    REMOVE_MOBILE_DONORBOX_URL } from './actionTypes';

const DEFAULT_STATE = {
    addUrl: undefined,
    getUrl: undefined

};

ReducerRegistry.register('features/donorbox', (state = DEFAULT_STATE, action) => {

    switch (action.type) {
    case ADD_DONORBOX_URL: {
        return {
            ...state,
            addUrl: action.addUrl
        };
    }
    case RECEIVE_DONORBOX_URL: {
        const url = action.getUrl;

        return {
            ...state,
            getUrl: action.getUrl ? url : state.getUrl
        };
    }

    case REMOVE_DONORBOX_URL: {
        return {
            ...state,
            getUrl: undefined
        };
    }

    case REMOVE_MOBILE_DONORBOX_URL: {
        return {
            ...state,
            getUrl: undefined
        };
    }
    }


    return state;
});
